
import { useState } from 'react';

export function DemoVideoSection() {
  const [activeDemo, setActiveDemo] = useState('dashboard');

  const demos = [
    {
      id: 'dashboard',
      title: 'Unified SME Dashboard',
      description: 'See how business owners get a clear overview of their security status, detected threats, and employee risk scores.',
      duration: '2:30',
      thumbnail: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop&crop=center'
    },
    {
      id: 'detection',
      title: 'AI Threat Detection',
      description: 'Watch our UK-trained AI analyze and block phishing emails and smishing SMS in real-time.',
      duration: '3:15',
      thumbnail: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=600&h=400&fit=crop&crop=center'
    },
    {
      id: 'training',
      title: 'Employee Training Nudges',
      description: 'Experience how employees receive instant educational alerts when risky behavior is detected.',
      duration: '1:45',
      thumbnail: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=600&h=400&fit=crop&crop=center'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Interactive Product Demo
            </h2>
            <p className="text-xl text-gray-400">
              Explore each feature of Driscop's cybersecurity platform
            </p>
          </div>

          {/* Demo Tabs */}
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Tab Navigation */}
            <div className="lg:w-1/3">
              <div className="space-y-4">
                {demos.map((demo) => (
                  <button
                    key={demo.id}
                    onClick={() => setActiveDemo(demo.id)}
                    className={`w-full text-left p-6 rounded-xl transition-all cursor-pointer ${
                      activeDemo === demo.id
                        ? 'bg-blue-500/20 border-2 border-blue-400'
                        : 'bg-gray-800/50 border-2 border-transparent hover:bg-gray-700/50'
                    }`}
                  >
                    <div className="flex items-start justify-between mb-3">
                      <h3 className={`text-lg font-semibold ${
                        activeDemo === demo.id ? 'text-blue-400' : 'text-white'
                      }`}>
                        {demo.title}
                      </h3>
                      <span className="text-sm text-gray-400 bg-gray-800/50 px-2 py-1 rounded border border-gray-600">
                        {demo.duration}
                      </span>
                    </div>
                    <p className="text-gray-400 text-sm">
                      {demo.description}
                    </p>
                  </button>
                ))}
              </div>
            </div>

            {/* Video Player */}
            <div className="lg:w-2/3">
              <div className="relative aspect-video bg-gray-900 rounded-xl overflow-hidden">
                <img
                  src={demos.find(d => d.id === activeDemo)?.thumbnail}
                  alt={demos.find(d => d.id === activeDemo)?.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                  <button className="w-20 h-20 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center border border-white/30 hover:bg-white/30 transition-all cursor-pointer">
                    <i className="ri-play-fill text-white text-3xl ml-1"></i>
                  </button>
                </div>
                <div className="absolute bottom-6 left-6 right-6">
                  <h3 className="text-white text-xl font-semibold mb-2">
                    {demos.find(d => d.id === activeDemo)?.title}
                  </h3>
                  <p className="text-gray-200">
                    {demos.find(d => d.id === activeDemo)?.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
